import { Outlet } from '@tanstack/react-router';

export function RootComponent() {
  return <Outlet />;
}
